'use client';
import { useState, useRef, useEffect } from 'react';
import type { ImgHTMLAttributes } from 'react';

// Спиннер на фото машин (/photos/ и shared-сток /images/stock/), новостях
// (/images/news/), темах (/images/themes/) и городах (/images/cities/ —
// карусель + блок станций). Всё остальное (иконки, лого, классы, декор
// /images/home/) — без лоадера.
const NEEDS_LOADER = /\/(photos\/|images\/(stock|news|themes|cities)\/)/i;

/** <img>, который прячется (opacity:0), пока грузится, а спиннер в цвет бренда
 *  показывает на своей ОБЁРТКЕ (родителе). По полной загрузке фото плавно
 *  проявляется целиком — не кусками под спиннером. */
export default function Img({ className, onLoad, onError, src, ...rest }: ImgHTMLAttributes<HTMLImageElement>) {
  const [done, setDone] = useState(false);
  const ref = useRef<HTMLImageElement>(null);
  let loader = false;
  try { loader = typeof src === 'string' && NEEDS_LOADER.test(decodeURIComponent(src)); } catch { loader = typeof src === 'string' && NEEDS_LOADER.test(src); }
  // Спиннер вешаем на родителя, пока фото не догрузилось. Картинка могла
  // загрузиться ДО гидратации — тогда onLoad не сработает, проверяем complete.
  useEffect(() => {
    if (!loader) return;
    const img = ref.current; if (!img) return;
    const wrap = img.parentElement;
    if (img.complete) { setDone(true); return; }
    wrap?.classList.add('nimg-load');
    return () => wrap?.classList.remove('nimg-load');
  }, [loader, src]);
  const finish = () => { setDone(true); ref.current?.parentElement?.classList.remove('nimg-load'); };
  const cls = `${className || ''} ${loader ? `nimg-fade ${done ? 'nimg-done' : ''}` : ''}`.trim();
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      ref={ref}
      src={src}
      {...rest}
      className={cls}
      onLoad={(e) => { finish(); onLoad?.(e); }}
      onError={(e) => { finish(); onError?.(e); }}
    />
  );
}
